import React from 'react';
import styles from './back-to-top-button.module.sass';
import { UpOutlined } from '@ant-design/icons';
import { Tooltip, BackTop } from 'antd';

export const BackToTopButton = () => {
  return (
    <BackTop
      className={styles.backToTopButton}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <Tooltip title="Go to the top of the page">
        <UpOutlined />
      </Tooltip>
    </BackTop>
  );
};
